import React, { useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, useFormHandler } from "../../../../components";
import { useSelector } from "react-redux";
import { addLeadCompany } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const AddCompanyModal = ({ onCancel, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const validationRules = {
        // Add validation rules as needed
        url: {
            type: "text",
            required: true,
        },
        companyName: {
            type: "text",
            required: true,
        },
    };
    const { user } = useSelector((state) => state.auth);
    const initialFormData = {
        // firstName: "",
        // lastName: "",
        // email: "",
        // designation: "",
        url: "",
        // phone: {
        //     code: "",
        //     number: ""
        // },
        selectedCompany: "",
    };

    const { formData, errors, handleChange, validateAllFields, setFormData } =
        useFormHandler(initialFormData, validationRules);

    const handleSave = async () => {
        const isValid = validateAllFields();
        if (!isValid) return;

        if (!formData.companyName?.trim()) {
            showToast("Please enter company name", "error");
            return;
        }
        if (!formData.url?.trim()) {
            showToast("Please enter company linkedIn url", "error");
            return;
        }

        try {
            setLoading(true);
            const body = {
                coll: "LeadCompany",
                payload: {
                    name: formData.companyName.trim(),
                    linkedInUrl: formData.url.trim(),
                    addedBy: user?.data?.uiid,
                },
            };

            const response = await addLeadCompany(body);

            if (response?.data) {
                showToast("Company added successfully", "success");
                onCancel();
                if (onSuccess) onSuccess();
            } else {
                const error = response?.error;
                if (error?.code === 11000) {
                    const name = error?.keyValue?.name;
                    showToast(
                        formData.companyName.trim()
                            ? `Company "${formData.companyName.trim()}" already exists`
                            : "Company already exists",
                        "error"
                    );
                } else {
                    showToast(
                        response?.data?.msg || "Failed to add company",
                        "error"
                    );
                }
            }
        } catch (error) {
            showToast(
                error?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="flex flex-col gap-5 p-4 sm:p-6">
            {/* <div className="w-full sm:w-1/2 lg:w-1/3">
                <FormFieldSet
                    type="search"
                    title="Search in existing company list"
                    placeholder="Search"
                    shadow={true}
                />
                <FormFieldSet
                    type="text"
                    title="URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.url}
                    onChange={(value) => handleChange("url", value)}
                    error={errors.url}
                />
            </div> */}

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                <div>
                    <FormFieldSet
                        type="allCompanies"
                        title="Search in existing company list"
                        placeholder="Search"
                        shadow={true}
                        showSearch
                        multiple={false}
                        value={formData.selectedCompany}
                        onChange={(value) => {
                            setFormData((prev) => ({
                                ...prev,
                                selectedCompany: value,
                                companyName: value?.label || "",
                            }));
                        }}
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        Select a company from the list to auto-fill the name, or add a new company by typing directly in the Company Name field.
                    </p>

                </div>
                <FormFieldSet
                    type="text"
                    title="Company Name"
                    placeholder="Enter company name"
                    shadow={true}
                    value={formData.companyName}
                    onChange={(value) => {
                        setFormData((prev) => ({
                            ...prev,
                            companyName: value,
                            selectedCompany: "",
                        }));
                    }}
                    required
                    error={errors.companyName}
                />
                <FormFieldSet
                    type="text"
                    title="Company LinkedIn URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.url}
                    onChange={(value) => handleChange("url", value)}
                    error={errors.url}
                    required
                />
                {/* <FormFieldSet
                    type="text"
                    title="First Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.firstName}
                    onChange={(value) => handleChange("firstName", value)}
                    error={errors.firstName}
                />

                <FormFieldSet
                    type="text"
                    title="Last Name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.lastName}
                    onChange={(value) => handleChange("lastName", value)}
                    error={errors.lastName}
                />

                <FormFieldSet
                    type="phone"
                    title="Phone"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.phone?.number || ""}
                    code={formData.phone?.code || ""}
                    onChange={(fullValue, details) =>
                        handleChange(`phone`, {
                            code: details.countryCode,
                            number: details.number,
                        })
                    }
                    error={errors.phone}
                />

                <FormFieldSet
                    type="text"
                    title="Email"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.email}
                    onChange={(value) => handleChange("email", value)}
                    error={errors.email}
                />

                <FormFieldSet
                    type="text"
                    title="Designation"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.designation}
                    onChange={(value) => handleChange("designation", value)}
                    error={errors.designation}
                /> */}

            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
                <Button
                    variant="outlined"
                    title="Cancel"
                    color="black"
                    onClick={() => onCancel()}
                    className="w-full sm:w-auto"
                />
                <Button
                    title="Save"
                    variant="contained"
                    color="primary"
                    className="w-full sm:w-auto"
                    onClick={() => handleSave()}
                />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default AddCompanyModal;